import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';

import { TranslatePipe } from 'app/core/i18n/translate.pipe';
import { AddressSelectDialogData } from '../../interfaces/dialog-data.interface';

@Component({
  selector: 'app-address-select-modal',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatRadioModule,
    TranslatePipe,
  ],
  template: `
    <div class="flex max-h-full min-h-0 w-full flex-col">
      <!-- header -->
      <div class="flex items-start justify-between px-6 pb-4 pt-6">
        <div class="flex items-start gap-2">
          <mat-icon class="text-primary mt-0.5">local_shipping</mat-icon>
          <div>
            <h2 class="text-xl font-bold">{{ 'DOCUMENT_GENERATE.ADDRESS_MODAL.TITLE' | t }}</h2>
            <p class="text-secondary text-sm">{{ 'DOCUMENT_GENERATE.ADDRESS_MODAL.SUBTITLE' | t }}</p>
          </div>
        </div>
        <button mat-icon-button type="button" (click)="cancel()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <!-- listado -->
      <div class="min-h-0 flex-1 overflow-auto border-t px-6 py-4">
        <mat-radio-group class="flex flex-col gap-3" [(ngModel)]="selectedId">
          @for (address of data.addresses; track address._id) {
          <label
            class="flex cursor-pointer items-start gap-3 rounded-xl border p-4 transition-colors"
            [class.border-primary]="selectedId === address._id.toString()"
            [class.bg-primary-50]="selectedId === address._id.toString()"
            [class.dark:bg-primary-900]="selectedId === address._id.toString()">
            <mat-radio-button [value]="address._id.toString()" class="mt-0.5"></mat-radio-button>
            <div class="flex min-w-0 flex-col gap-0.5">
              <span class="text-primary min-h-[1.25rem] text-sm font-semibold">{{ codeOf(address) }}</span>
              <span class="whitespace-pre-line leading-snug">{{ address.address }}</span>
            </div>
          </label>
          }
        </mat-radio-group>
      </div>

      <!-- footer -->
      <div class="flex justify-end gap-3 border-t bg-gray-50 px-6 py-4 dark:bg-transparent">
        <button mat-stroked-button type="button" (click)="cancel()">{{ 'GENERAL.CANCEL' | t }}</button>
        <button mat-flat-button color="primary" type="button" [disabled]="!selectedId" (click)="confirm()">
          {{ 'DOCUMENT_GENERATE.ACTIONS.CONFIRM' | t }}
        </button>
      </div>
    </div>
  `,
})
export class AddressSelectModalComponent {
  selectedId: string | null = null;

  constructor(
    private dialogRef: MatDialogRef<AddressSelectModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AddressSelectDialogData
  ) {}

  codeOf(a: any): string {
    return a?.externalKeys?.code || a?.code || '';
  }

  confirm(): void {
    const found = this.data.addresses.find((a) => a._id.toString() === this.selectedId);
    this.dialogRef.close(found);
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
